import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext.ts';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import preloadOperationsQueryNode from './__generated__/preloadOperationsQuery.graphql.ts';
import type { GraphQLError } from 'graphql';

export async function preloadOperations(): Promise<
	| {
			data: unknown;
			errors?: ReadonlyArray<GraphQLError>;
			hasErrors: boolean;
	  }
	| undefined
> {
	const { userId } = getPreloaderFnContext();
	if (!userId) {
		return;
	}

	return query({ query: preloadOperationsQueryNode });
}
